export default __webpack_public_path__ + "static/media/cf-logo-v.e4b30a67.svg";